<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface" id="int"><span class="center"><em>Introduction</em></span></h1>
<p class="center"><span class="center">They dated for 27 years, two months, three weeks, and one day.</span></p>
<p class="center"><span class="center">She was devoted, he was a pig.</span></p>
<p class="center"><span class="center">She became enlightened, he remained oblivious.</span></p>
<p class="center"><span class="center">She aspired to “goddess,” he clung to “king.”</span></p>
<p class="center"><span class="center">She walked, he wooed her back.</span></p>
<p class="center"><span class="center">She came back, he ran away.</span></p>
<p class="center"><span class="center">She studied books, tapes, and astrological charts to understand him.</span></p>
<p class="center"><span class="center">He watched sports.</span></p>
<p class="center"><span class="center">She went to workshops, retreats, psychics, seminars, and shrinks.</span></p>
<p class="center"><span class="center">He took up golf.<br/><br/></span></p>
<p class="center"><span class="center">And yet…</span></p>
<p class="center"><span class="center">He kept sliding back into her life, each time a little bit changed.</span></p>
<p class="center"><span class="center">He gained weight, lost hair, changed careers, suffered midlife sports injuries and severe sprains to all major ego groups.</span></p>
<p class="center"><span class="center">He got open, vulnerable, and available. She got disgusted, indignant, and left.<br/><br/></span></p>
<p class="center"><span class="center">He had his heart broken by a woman named Lydia.</span></p>
<p class="center"><span class="center">She almost married a man named Alex.</span></p>
<p class="center"><span class="center">They each found true love at the animal shelter.<br/><br/></span></p>
<p class="center"><span class="center">They survived the most divisive years in history between men and women.</span></p>
<p class="center"><span class="center">They weathered the “Me” decade, the “We” decade, the information age, the digital revolution, the communication explosion, the militancy of the ’70s, the greed of the ’80s, the regrouping of the ’90s, the humility of the ’00s, at least 9,865 diets, and many, many, many total eclipses of the sense of humor.<br/><br/></span></p>
<p class="center"><span class="center">Behind the scenes, they fell in love.</span></p>
<p class="center"><span class="center">Between the strips, there remained something unsettled.</span></p>
<p class="center"><span class="center">Until finally, after 27 years, two months, three weeks, and one day they were, for the very first time, in the exact same place at the exact same time: completely, utterly, with all their hearts, ready to give up.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740799426_epub_int_r1.vue?061ef083